// extracted by mini-css-extract-plugin
export default {"gradient-bg5":"avatar__gradient-bg5__PWNoH","avatar":"avatar__avatar__kywGF","initials":"avatar__initials__HzhNw"};